import { render, staticRenderFns } from "./SalesDetailsIcon.vue?vue&type=template&id=1bfb6730&"
import script from "./SalesDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./SalesDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports